<template>
  <v-layout column>
    <v-layout>
      <top-info-panel>
        <v-flex xs12 md12 lg8 xl5 px-2 slot="content">
          <h4>Beheer hardware types</h4>
          <p>
            Via het beheer van hardware types kunt u vele configuratie instellingen voor de door u gebruikte hardware types wijzigen. Ook kunt u events, workflows, geofencing en datavelden beheren.
          </p>
        </v-flex>
      </top-info-panel>
    </v-layout>
    <v-layout wrap px-3 align-center justify-center class="inset">
      <v-flex
        xs12
        md12
        pt-2
        :class="showWorkflowConfigurator ? 'lg12 xl8' : 'lg8 xl5'"
        style="min-height:540px;"
      >
        <!-- <transition-group mode="out-in" name="unittypecontainer" enter-active-class="fadeIn custom" leave-active-class="fadeOut custom">                  -->
        <!--- UNIT TYPE OVERVIEW  ------------------------------------------------------------------------------------>
        <v-flex v-if="!selectedUnitType" class="animated">
          <v-widget title="Assetunitsoorten beheren">
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4>
                <h5>Selecteer een unitsoort:</h5>
              </v-flex>
              <v-flex xs12 pt-2>
                <v-data-table :headers="grids.unitTypeHeaders" :items="unitTypes" hide-actions>
                  <template slot="items" slot-scope="props">
                    <tr @click="selectUnitType(props.item)">
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-center">{{ props.item.events.length}}</td>
                      <td class="text-xs-center">{{ props.item.timeSeries.length}}</td>
                      <td class="text-xs-center">{{ props.item.dataFields.length}}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
        <!--- UNIT TYPE DETAILS ------------------------------------------------------------------------------------>
        <v-flex
          v-if="showDetailScreen"
          class="animated"
        >
          <v-widget :title="`Overzicht: ${selectedUnitType.name}`">
            <v-btn fab dark color="accent" slot="button-top-right" @click="reset()">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs1>
                <v-layout class="layout" wrap row pa-2 grey lighten-4 pt-4>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Naam</div>
                    <div class="dd-value">{{selectedUnitType.name}}</div>
                  </v-flex>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Standaard minuten per interval</div>
                    <div class="dd-value">{{selectedUnitType.defaultIntervalMinutes}}</div>
                  </v-flex>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Eventnaam positiewijziging</div>
                    <div class="dd-value">{{selectedUnitType.positionEvent}}</div>
                  </v-flex>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Route registratie actief</div>
                    <div class="dd-value">{{selectedUnitTypeHasRoutes}}</div>
                  </v-flex>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Eventnaam route start</div>
                    <div
                      class="dd-value"
                    >{{selectedUnitType.routeStartEvent ? selectedUnitType.routeStartEvent : "Geen"}}</div>
                  </v-flex>
                  <v-flex xs12 md6 pb-2>
                    <div class="dd-label">Eventnaam route einde</div>
                    <div
                      class="dd-value"
                    >{{selectedUnitType.routeStartEvent ? selectedUnitType.routeStartEvent : "Geen"}}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
        <!-- TABS ---------------------------->
                <v-tabs v-model="selectedTab" grow>
                  <v-tab key="unit_type_events">Events</v-tab>
                  <v-tab key="unit_type_geo_events">Geo events</v-tab>
                  <v-tab key="unit_type_time_series">Datastromen</v-tab>
                  <v-tab key="unit_type_data_fields">Datavelden</v-tab>
                  <v-tab key="unit_type_status_by_data_field">Statussen</v-tab>                  
                </v-tabs>
                <v-tabs-items v-model="selectedTab">
                  <v-tab-item key="unit_type_events">
        <!-------------- UNIT TYPE EVENT TAB -------------------------------------->
                    <v-flex xs12>
                      <v-layout column wrap>
                        <v-flex xs12 pb-2 pt-4>
                          <h5>{{selectedUnitTypeMainEvents.length}} hoofd events op unit:</h5>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-data-table
                            no-data-text="Geen events toegewezen"
                            :items="selectedUnitTypeMainEvents"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                          >
                            <template
                              slot="items"
                              slot-scope="props"
                              v-if="!props.item.isCancelEvent && !props.item.isDoneEvent"
                            >
                              <tr @click="selectUnitTypeEvent(props.item)">
                                <td>{{ props.item.name }}</td>
                                <td class="text-xs-right">
                                  <v-chip
                                    v-if="props.item.isWorkflowStart"
                                    text-color="white"
                                    color="secondary"
                                    small
                                  >workflow</v-chip>
                                </td>
                                <td class="text-xs-right">
                                  <v-chip
                                    :color="getInternalNameColor(props.item.eventType.internalName)"
                                    dark
                                    label
                                    small
                                    outline
                                  >{{ props.item.eventType.name }}</v-chip>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-layout row wrap justify-end pt-2>
                            <v-btn
                              @click="showUnitTypeEventForm=true"
                              color="accent"
                              small
                            >Nieuw event aanmaken</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
                  <v-tab-item key="unit_type_geo_events">
    <!-------------- UNIT TYPE GEO_EVENT TAB -------------------------------------->
                    <v-flex xs12>
                      <v-layout column wrap>
                        <v-flex xs12 pb-2 pt-4>
                          <h5>{{selectedUnitTypeGeoEvents.length}} geo events op unit:</h5>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-data-table
                            no-data-text="Geen geo events toegewezen"
                            :items="selectedUnitTypeGeoEvents"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                          >
                            <template
                              slot="items"
                              slot-scope="props"
                              v-if="!props.item.isCancelEvent && !props.item.isDoneEvent"
                            >
                              <tr @click="selectUnitTypeEvent(props.item)">
                                <td>{{ props.item.name }}</td>
                                <td class="text-xs-right">
                                    {{ geoZoneNameOnGeoEvent(props.item)}}                                    
                                </td>
                                <td class="text-xs-right">
                                  <v-chip
                                    :color="getInternalNameColor(props.item.eventType.internalName)"
                                    dark
                                    label
                                    small
                                    outline
                                  >{{ props.item.eventType.name }}</v-chip>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
        <!-------------- UNIT TYPE TIMESERIES TAB -------------------------------------->
                  <v-tab-item key="unit_type_time_series">
                    <v-flex xs12>
                      <v-layout column wrap>
                        <v-flex xs12 pb-2 pt-4 d-flex justify-space-between align-center>
                          <h5>{{selectedUnitType.timeSeries.length}} datastromen op unit:</h5>
                          <div
                            v-if="unitTypeHasMoreThenOnePrimaryTimeSeries"
                            style="text-align:right; display:flex"
                          >
                            <i
                              class="fas fa-exclamation-triangle"
                              style="color:orange; padding-top:2px"
                            ></i>
                            <div
                              style="padding-left:4px; color:orange;"
                            >Let op! er is meer dan 1 primaire datastroom ingesteld</div>
                          </div>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-data-table
                            no-data-text="Geen datastromen toegewezen"
                            :items="selectedUnitType.timeSeries"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                          >
                            <template slot="items" slot-scope="props">
                              <tr @click="selectTimeSerie(props.item)">
                                <td>{{ props.item.name }}</td>
                                <td>{{props.item.unitOfMeasure}}</td>
                                <td class="text-xs-right">
                                  <v-chip
                                    v-if="props.item.isPrimary"
                                    small
                                    color="orange"
                                    text-color="white"
                                  >primaire datastroom</v-chip>
                                </td>                                
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap justify-end pt-2>
                        <v-btn
                          color="accent"
                          @click="showTimeSeriesForm=true"
                          small
                        >Nieuwe datastroom aanmaken</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
          <!-------------- UNIT TYPE DATAFIELDS TAB -------------------------------------->
                  <v-tab-item key="unit_type_data_fields">
                    <v-flex xs12>
                      <v-layout column wrap>
                        <v-flex xs12 pb-2 pt-4 d-flex justify-space-between align-center>
                          <h5>{{selectedUnitType.dataFields.length}} datavelden op unitsoort:</h5>
                          <div v-if="unitTypeHasMoreThenOnePrimaryDataField" style="text-align:right; display:flex">
                            <i class="fas fa-exclamation-triangle" style="color:orange; padding-top:2px"></i>
                            <div style="padding-left:4px; color:orange;">Let op! er is meer dan 1 primaire dataveld ingesteld</div>
                          </div>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <v-data-table
                            no-data-text="Geen datavelden toegewezen"
                            :items="selectedUnitType.dataFields"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                          >
                            <template slot="items" slot-scope="props">
                              <tr @click="selectDataField(props.item)">
                                <td><i v-if="props.item.icon" :class="props.item.icon"></i></td>
                                <td>{{ props.item.customField.name }}</td>
                                <td>{{props.item.customField.type.name}}</td>
                                <td class="text-xs-right"></td>
                                  <v-chip
                                    v-if="props.item.isPrimary"
                                    small
                                    color="orange"
                                    text-color="white"
                                  >primaire dataveld</v-chip>
                                </td>
                                
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap justify-end pt-2>
                        <v-btn
                          color="accent"
                          @click="showDataFieldForm=true"
                          small
                        >Nieuw dataveld aanmaken</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
        <!-------------- UNIT TYPE STATUS BY DATA FIELD TAB -------------------------------------->
                  <v-tab-item key="unit_type_status_by_data_field">
                    <v-flex xs12>
                      <v-layout column wrap>
                        <v-flex xs12 pb-2 pt-4 d-flex justify-space-between align-center>
                          <h5>Alle statussen op datavelden van unitsoort:</h5>
                        </v-flex>                               
                        <v-flex xs12 pt-2>
                          <v-data-table
                            no-data-text="Geen statussen toegewezen"
                            :items="statusByDataFields"
                            class="elevation-1"
                            hide-actions
                            hide-headers
                          >
                            <template slot="items" slot-scope="props">
                              <tr @click="selectStatusField(props.item)">                                                              
                                <td>{{props.item.sortOrder}}</td>
                                <td><div class="color-picker-preview" :style="`background-color:${props.item.color}`"></div></td>                                
                                <td>{{props.item.name}}</td>                            
                                <td><i v-if="props.item.dataField.icon" :class="props.item.dataField.icon"></i> {{ props.item.dataField.name }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>                        
                        <v-flex xs12 md6>
                          <v-layout row wrap justify-end pt-2>
                            <v-btn
                              @click="showStatusForm=true"
                              color="accent"
                              small
                            >Nieuwe status aanmaken</v-btn>
                          </v-layout>
                        </v-flex>                        
                      </v-layout>
                    </v-flex>
                  </v-tab-item>                  
                </v-tabs-items>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
    <!------- UNIT TYPE EVENT DETAILS ------------------------------------------------------------------------------------>
        <v-flex v-if="showUnitTypeEventForm" class="animated">
          <v-widget :title="`${selectedUnitType.name} event: ${selectedUnitTypeEventTitle}  `">
            <v-btn fab dark color="accent" slot="button-top-right" @click="unitTypeDetailScreen">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4></v-flex>
              <v-flex xs12 pt-2>
                <!---------- UNIT TYPE EVENT FORM ---------------------------------------------------------------------->
                <unit-type-event-form
                  :unitTypeId="selectedUnitType.id"
                  :unitTypeEvent="selectedUnitTypeEvent"
                  @saved="unitTypeEventSaved"
                  @cancelClicked="cancelUnitTypeEventForm"
                  @workflowClicked="openWorkflowScreen"
                ></unit-type-event-form>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
        <v-flex v-if="showWorkflowConfigurator" class="animated">
      <!------------ WORKFLOW CONFIGURATOR -------------------------------------------------------------------------------------->
          <v-widget :title="`Workflow instellen voor: ${selectedUnitTypeEventTitle}`">
            <v-btn
              fab
              dark
              color="accent"
              slot="button-top-right"
              @click="showWorkflowConfigurator=false; showUnitTypeEventForm=true"
            >
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs12 pt-2 style="min-height:550px;">
                <!---------- UNIT TYPE EVENT FORM ---------------------------------------------------------------------->
                <workflow-configurator
                  :rootUnitTypeEvent="selectedUnitTypeEvent"
                  :unitTypeId="selectedUnitType.id"
                ></workflow-configurator>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
      <!------- UNIT TYPE EVENT DETAILS ------------------------------------------------------------------------------------>
        <v-flex v-if="showTimeSeriesForm" class="animated">
          <v-widget :title="`${selectedUnitType.name} datastroom: ${selectedTimeSerieTitle}  `">
            <v-btn fab dark color="accent" slot="button-top-right" @click="unitTypeDetailScreen">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4></v-flex>
              <v-flex xs12 pt-2>
                <!---------- UNIT TYPE EVENT FORM ---------------------------------------------------------------------->
                <time-serie-form
                  :unitTypeId="selectedUnitType.id"
                  :timeSerie="selectedTimeSerie"
                  @saved="timeSerieSaved"
                  @cancelClicked="unitTypeDetailScreen"
                ></time-serie-form>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>
      <!------- UNIT TYPE DATA FIELD DETAILS------------------------------------------------------------------------------------>
        <v-flex v-if="showDataFieldForm" class="animated">
          <v-widget :title="`${selectedUnitType.name} dataveld: ${selectedDataFieldTitle}  `">
            <v-btn fab dark color="accent" slot="button-top-right" @click="unitTypeDetailScreen">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4></v-flex>
              <v-flex xs12 pt-2>
                <!---------- UNIT TYPE DATA FIELD FORM ---------------------------------------------------------------------->
                <data-field-form
                  :unitTypeId="selectedUnitType.id"
                  :dataField="selectedDataField"
                  @saved="dataFieldSaved"
                  @cancelClicked="unitTypeDetailScreen"
                ></data-field-form>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>        
      <!------- UNIT TYPE DATA FIELD STATUS FORM------------------------------------------------------------------------------------>
        <v-flex v-if="showStatusForm" class="animated">
          <v-widget :title="`${selectedUnitType.name} status: ${selectedStatusTitle}  `">
            <v-btn fab dark color="accent" slot="button-top-right" @click="unitTypeDetailScreen">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
            <v-layout slot="widget-content" column>
              <v-flex xs12 pb-2 pt-4></v-flex>
              <v-flex xs12 pt-2>
                <!---------- UNIT TYPE DATA FIELD FORM ---------------------------------------------------------------------->
                <data-field-status-form
                  :unitTypeId="selectedUnitType.id"
                  :dataFieldStatus="selectedStatus"
                  @saved="statusSaved"
                  @cancelClicked="unitTypeDetailScreen"
                ></data-field-status-form>
              </v-flex>
            </v-layout>
          </v-widget>
        </v-flex>   
      </v-flex>     
      <!-- </transition-group> -->
    </v-layout>
  </v-layout>
</template>
<script>
import * as types from "../../store/types"
import { mapGetters } from "vuex"
import VWidget from "../../components/global/VWidget"
import TopInfoPanel from "../../components/global/TopInfoPanel"
import Notification from "../../components/global/Notification"
import UnitTypeEventForm from "../../components/event/unitTypeEventForm"
import TimeSerieForm from "../../components/timeSeries/TimeSerieForm"
import DataFieldForm from "../../components/dataFields/DataFieldForm"
import DataFieldStatusForm from "../../components/dataFields/DataFieldStatusForm"
import WorkflowConfigurator from "../../components/workflow/workflowConfigurator"
import { colors } from "../../config"
import _ from "lodash";

export default {
  data() {
    return {
      selectedTab: 0,
      grids: {
        unitTypeHeaders: [
          { text: "Hardware", sortable: false },
          { text: "Events gekoppeld", sortable: false },
          { text: "Datastromen gekoppeld", sortable: false },
          { text: "Datavelden", sortable: false }
        ]
      },
      selectedUnitType: null,
      selectedUnitTypeEvent: null,
      selectedTimeSerie: null,
      selectedDataField:null,
      selectedStatus:null,
      newEventForUnitTypeId: null,
      showUnitTypeEventForm: false,
      showTimeSeriesForm: false,
      showStatusForm:false,
      showWorkflowConfigurator: false,
      showDataFieldForm:false,
      
    };
  },
  computed: {
    ...mapGetters({
      unitTypes: types.UNIT_TYPES,
      statusByDataFields:types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS
    }),
    showDetailScreen(){
        return ( this.selectedUnitType && 
                !this.showUnitTypeEventForm && 
                !this.showWorkflowConfigurator && 
                !this.showTimeSeriesForm &&
                !this.showDataFieldForm &&
                !this.showStatusForm
        ) ? true : false
    },
    selectedUnitTypeHasRoutes() {
      return this.selectedUnitType && this.selectedUnitType.hasRoutes
        ? "Ja"
        : "Nee";
    },
    selectedUnitTypeEventTitle() {
      return this.selectedUnitTypeEvent
        ? this.selectedUnitTypeEvent.name
        : "Nieuw event";
    },
    selectedTimeSerieTitle() {
      return this.selectedTimeSerie ? this.selectedTimeSerie.name : "Nieuw"
    },
    selectedDataFieldTitle(){
      return this.selectedDataField ? this.selectedDataField.name : "Nieuw"
    },
    selectedStatusTitle(){
      return this.selectedStatus ? this.selectedStatus.name : "Nieuw"
    },
    selectedUnitTypeGeoEvents(){
       return this.selectedUnitType.events.filter( (event) =>  { 
          return (event.asGeoZoneEnterEvent || event.asGeoZoneExitEvent)
       })
    },
    selectedUnitTypeMainEvents() {
      // it qualifies as main event if it does not belong to a GeoZoneEvent OR a event Action
      return this.selectedUnitType.events.filter( (event) =>  { 
         return (!event.asGeoZoneEnterEvent && !event.asGeoZoneExitEvent && !event.isDoneEvent && !event.isCancelEvent)
      })
    },
    unitTypeHasMoreThenOnePrimaryTimeSeries() {
      if (!this.selectedUnitType) return false
      let i = 0;
      this.selectedUnitType.timeSeries.forEach(timeSerie => {
        if (timeSerie.isPrimary) i++
        if (i > 1) return;
      });
      return i > 1 ? true : false
    },
    unitTypeHasMoreThenOnePrimaryDataField(){
      if (!this.selectedUnitType) return false
      let i = 0;
      this.selectedUnitType.dataFields.forEach(timeSerie => {
        if (timeSerie.isPrimary) i++
        if (i > 1) return
      });
      return i > 1 ? true : false
    }
  },
  methods: {
    geoZoneNameOnGeoEvent(event){
        return event.asGeoZoneEnterEvent ? event.asGeoZoneEnterEvent.geoZone.name : event.asGeoZoneExitEvent.geoZone.name
    },
    unitTypeDetailScreen() {
      this.selectedUnitTypeEvent = null
      this.showUnitTypeEventForm = false
      this.showWorkflowConfigurator = false
      this.selectedTimeSerie = null
      this.showTimeSeriesForm = false
      this.selectedDataField = null
      this.showDataFieldForm = false
      this.selectedStatus = null
      this.showStatusForm = false
    },
    cancelUnitTypeEventForm() {
      this.selectedUnitTypeEvent = null
      this.showUnitTypeEventForm = false
    },
    getInternalNameColor(internal_name) {
      return colors[internal_name] ? colors[internal_name] : ""
    },
    selectUnitType(unitType) {
      this.selectedUnitType = unitType
      this.loadSelectedUnitTypeDataFieldStatuses()
    },
    selectUnitTypeEvent(unitTypeEvent) {
      if (unitTypeEvent) {
        this.selectedUnitTypeEvent = unitTypeEvent
      }
      this.showUnitTypeEventForm = true
    },
    unitTypeEventSaved(savedEvent) {
      let text = "Event " + savedEvent.name + " succesvol "
      text += this.selectedUnitTypeEvent ? "aangepast" : "aangemaakt"
      this.$notify(text, { color: "green", duration: 1000 })
      this.selectedUnitTypeEvent = null;
      this.showUnitTypeEventForm = false;
      this.loadUnitTypes();
    },
    selectTimeSerie(timeSerie) {
      this.selectedTimeSerie = timeSerie
      this.showTimeSeriesForm = true
    },
    timeSerieSaved(savedTimeSerie) {
      let text = "Datastroom " + savedTimeSerie.name + " succesvol "
      text += this.selectedTimeSerie ? "aangepast" : "aangemaakt"
      this.$notify(text, { color: "green", duration: 1000 })

      this.selectedTimeSerie = null
      this.showTimeSeriesForm = false
      this.loadUnitTypes();
    },
    selectDataField(dataField){
      this.selectedDataField = dataField
      this.showDataFieldForm = true
    },
    dataFieldSaved(savedDataField){
      let text = "Dataveld " + savedDataField.name + " succesvol "
      text += this.selectedDataField ? "aangepast" : "aangemaakt"
      this.$notify(text, { color: "green", duration: 1000 })

      this.selectedDataField = null
      this.showDataFieldForm = false
      this.loadUnitTypes();
    },
    selectStatusField(statusField){
      this.selectedStatus = statusField      
      this.showStatusForm = true
    },
    statusSaved(savedStatus){
      let text = "Status " + savedStatus.name + " succesvol "
      text += this.selectedStatus ? "aangepast" : "aangemaakt"
      this.$notify(text, { color: "green", duration: 1000 })
      this.loadSelectedUnitTypeDataFieldStatuses()
      this.unitTypeDetailScreen()
      this.loadUnitTypes()
    },    
    reset() {
      this.selectedUnitType = null
      this.selectedUnitTypeEvent = null
      this.unitTypeDetailScreen()
      this.loadUnitTypes()
    },
    openWorkflowScreen() {
      this.showUnitTypeEventForm = false
      this.showWorkflowConfigurator = true
    },
    loadUnitTypes() {
      let vm = this;
      let includes = `events.eventType, 
                      events.eventSeverity, 
                      events.asGeoZoneEnterEvent, 
                      events.asGeoZoneEnterEvent.geoZone, 
                      events.asGeoZoneExitEvent, 
                      events.asGeoZoneExitEvent.geoZone, 
                      timeSeries, 
                      dataFields.customField.type`
       
      this.$store
        .dispatch(types.UNIT_TYPES, {
          params: {
            per_page:200,
            include:includes              
          }
        })
        .then(() => {
          // reload selected unit type if there is one selected
          if (vm.selectedUnitType) {
            for (let i in vm.unitTypes) {
              if (vm.unitTypes[i].id == vm.selectedUnitType.id) {
                vm.selectedUnitType = vm.unitTypes[i];
              }
            }
          }
        });
    },
    loadSelectedUnitTypeDataFieldStatuses(){
      let id = this.selectedUnitType.id
      this.$store.dispatch(types.UNIT_TYPE_STATUSES_BY_DATA_FIELDS, {data:{unit_type_id:id}, params: {sort_by:"sortOrder",per_page:"200", include:"dataField,event"}}).then(() => {})      
    }
  },
  components: {
    VWidget,
    TopInfoPanel,
    Notification,
    UnitTypeEventForm,
    TimeSerieForm,
    DataFieldForm,
    WorkflowConfigurator,
    DataFieldStatusForm
  },
  mounted() {
    this.reset()
  }
};
</script>

<style scoped>
.dd-label {
  color: #bdbdbd;
  font-size: 14px;
}
.dd-value {
  color: #757575;
  font-size: 16px;
}
.cap_only[value] {
  text-transform: uppercase;
}
.custom-speed {
  animation-duration: 300ms;
}

.color-picker-preview{
    margin-left:4px; 
    width:20px; 
    height:20px; 
    border:1px 
    solid black;    
    cursor:pointer;    
}
</style>